import { defineMessages } from 'react-intl';
import { ACCOUNT, RECIPIENT, THIRD_PARTY, COLLECT } from '../../../../../enums/bill-to-party';

export const messages = defineMessages({
  [ACCOUNT]: {
    id: 'BNz8Qv',
    description: 'My account option in shipping accounts filter',
    defaultMessage: 'My Account',
  },
  [RECIPIENT]: {
    id: 'r2kRpi',
    description: 'Recipients option in shipping accounts filter',
    defaultMessage: 'Recipients',
  },
  [THIRD_PARTY]: {
    id: 'LJeNdt',
    description: 'Third Parties option in shipping accounts filter',
    defaultMessage: 'Third Parties',
  },
  [COLLECT]: {
    id: 'vRL20i',
    description: 'Collect option in shipping accounts filter',
    defaultMessage: 'Collect',
  },
});
